<template>
  <div class="pricing">
    <v-toolbar
      color="primary"
      dark
      class="mb-3"
    >
      
      <v-toolbar-title><slot name="title"/></v-toolbar-title>
    
      <v-spacer></v-spacer>
      
    </v-toolbar>
    
    <slot name="videoCollection"/>
    <!--
    <div class="btn-area">
      <v-btn
        :color="'secondary'"
        block
        large
        class="button"
      >
        See all...
      </v-btn>
    </div>
    -->
  </div>
  
</template>
<style lang="scss" scoped>
  @import '../../assets/styles.scss';
</style>

<script>
  export default {
    head() {
      return {
        title:   ' - Home Page'
      }
    }
  }
</script>
